export const MAX_IMAGES_PRE_IMAGE_BLOCK = 4;
